import { DASHCOLORS } from 'bd-web-components'
import styled, { css } from 'styled-components'

interface ExceptionContainerProps {
  height: number
  margin: boolean
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  margin-bottom: 162px;
  padding: 0px 64px;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const PageTitle = styled.h4`
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px;
  margin-top: 40px;
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    margin-top: 27px;
    margin-bottom: 13px;
  }
`

export const PageSubtitle = styled.p`
  color: ${DASHCOLORS.GRAY_SCALE_05};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 18px;
  }
`

export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`

export const TextHeaderBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ButtonHeaderBox = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
  }
`

export const FormDivider = styled.div`
  background-color: ${DASHCOLORS.GRAY_SCALE_08};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  margin-bottom: 42px;
  @media (max-width: 768px) {
    margin-top: 29px;
    margin-bottom: 42px;
  }
`

export const StyledForm = styled.form``

export const GridForm = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 660px;
  gap: 24px;
`

export const HorizontalContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const RegistrationBox = styled.div`
  width: 40%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const OwnerBox = styled.div`
  width: 60%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const TransactionTypeBox = styled.div`
  width: 100%;
`

export const BankBox = styled.div`
  width: 100%;
`

export const AgencyBox = styled.div`
  width: 30%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const AccountTypeBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const AccountNumberBox = styled.div`
  width: 85%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const DigitBox = styled.div`
  width: 15%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const AccountIdentifierBox = styled.div`
  width: 100%;
`

export const PixTypeKeyBox = styled.div`
  width: 40%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const PixKeyBox = styled.div`
  width: 60%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 24px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const SaveButtonBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const CancelButtonBox = styled.div`
  width: 30%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ExceptionContainer = styled(styled.div``) <ExceptionContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`
